const deepFreezeInner = (object: object, frozen: WeakSet<any>) => {
  if (Object.isFrozen(object)) {
    //also works on incremental freeze, because you cannot mutate frozen object. Assuming frozen object is frozen deeply previously.
    return object;
  }

  if (frozen.has(object)) {
    // to avoid infinite loops
    return object;
  }

  frozen.add(object);

  const propNames = Reflect.ownKeys(object);

  // deep-first is important
  for (const name of propNames) {
    const value = (object as any)[name];
    if (value && typeof value === 'object') {
      //todo  || typeof value === 'function') {
      // hack for (https://github.com/wix-private/dealer/blob/a429a23b1e6325321913eff84f26bb8227856b58/packages/react-dealer-viewer/src/components/DealerViewer/DealerViewer.tsx#L268)
      // if ('getI18n' in value) {
      //   continue;
      // }
      deepFreezeInner(value, frozen);
    }
  }

  return Object.freeze(object);
};

export default <T extends object>(object: T): T => {
  return deepFreezeInner(object, new WeakSet()) as any;
};
